import { BaseBody, BaseTitle } from '../Typography';
import { Box, styled } from '@mui/material';
import { PrimaryButton } from '../Buttons';
import EmptyUIIcon from '../icons/EmptyUIIcon';

export const Root = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 45px;
  padding: 60px 30px;
  flex: 1;
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const Content = styled(Box)``;

export const Title = styled(BaseTitle)`
  font-size: 38px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.95px;
  text-transform: capitalize;
  margin-bottom: 0px;
  line-height: 48px;
`;

export const Body = styled(BaseBody)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.45px;
  max-width: 400px;
  line-height: 32px;
  margin-bottom: 20px;
`;

export const RedirectButton = styled(PrimaryButton)``;

export const EmptyUIIconStyled = styled(EmptyUIIcon)`
  width: 100%;
  height: 100%;
  max-width: 510px;
  max-height: 292px;
`;
